// Pure display helper (IM-1907): read a backend-provided vol value straight
// off the live vol-surface snapshot (see use-live-vol-surface.ts —
// Record<tenorKey, Record<volLabel, number>>, vols as decimals).
//
// HARD RULE (William): the front end displays engine-provided values only —
// no analytics, no derived quantities. So this does a plain nested lookup by
// the exact tenor key ('1W'/'1M') and label ('ATMF'/'25RR') the backend
// returns — NO tenor interpolation and NO 25RR = 25C - 25P computation. If a
// key is absent the value is null and the tile renders "—".
//
// The only transform is the decimal -> percentage-point scaling (* 100),
// which is pure display formatting and matches the cm_time_series and
// market-data (use-vols-data.ts) paths verbatim.
import { VolSurfaceTenors } from '../../providers/exotics-tokens/use-implied-vol-smile';

export const readSurfaceVolPercent = (
  tenors: VolSurfaceTenors | null,
  tenor: string,
  label: string,
): number | null => {
  const map = tenors?.[tenor];
  if (!map || typeof map !== 'object') return null;
  const raw = map[label];
  return typeof raw === 'number' && Number.isFinite(raw) ? raw * 100 : null;
};
